import { render, staticRenderFns } from "./deletewaring.vue?vue&type=template&id=13f6cffd&"
import script from "./deletewaring.vue?vue&type=script&lang=ts&"
export * from "./deletewaring.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "deletewaring.vue"
export default component.exports